import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { LayersService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class LayerBloc extends Bloc<LayersService['layerControllerGetOne']> {
    public constructor(service: LayersService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.layerControllerGetOne.bind(service), {
            debug: debug ?? false,
        });
    }
}
